import { sureOf } from "../../../utils/CommonUtils";
import { buildBrandedElementRoots, GroupTree, } from "./tree/SDKDTGroupTree";
import { GroupTreeNode } from "./tree/SDKDTGroupTreeNode";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Tool implementation
/** Utility allowing merging of two distinct token trees */
export class DTTokenGroupTreeMerger {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Properties
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Merger
    makeGroupsDiff(tokensDiff, existingElements) {
        // Construct roots to take data from
        const exitingRoots = buildBrandedElementRoots(existingElements);
        const desiredStructures = new Map();
        // Make group structure
        tokensDiff.toCreateOrUpdate.forEach((node) => {
            var _a, _b;
            const nameParts = node.path.map((s) => s.trim());
            nameParts.shift();
            let typeRoots = desiredStructures.get(node.token.brandId);
            if (!typeRoots) {
                typeRoots = new Map();
                desiredStructures.set(node.token.brandId, typeRoots);
            }
            let typeRoot = typeRoots.get(node.token.tokenType);
            if (!typeRoot) {
                const rootElem = (_b = (_a = exitingRoots
                    .get(node.token.brandId)) === null || _a === void 0 ? void 0 : _a.get(node.token.tokenType)) === null || _b === void 0 ? void 0 : _b.element;
                typeRoot = new GroupTree(sureOf(rootElem));
                typeRoots.set(node.token.tokenType, typeRoot);
            }
            const group = typeRoot.getOrCreateGroup(nameParts);
            group.children.push(new GroupTreeNode(node.token, typeRoot));
            // if (elem instanceof TokenGroup) {
            // Ensure tokens are above groups by sorting
            // group.applyDefaultSorting()
            // }
        });
        // Next up - construct results
        const toUpdate = [];
        const toCreate = [];
        const toDelete = [];
        const compareDesiredAndExisting = (importNode, existingNode) => {
            if (importNode.isGroup) {
                let isChildGroupChanged = false;
                importNode.children.forEach((c) => {
                    var _a;
                    const existingChild = ((_a = existingNode === null || existingNode === void 0 ? void 0 : existingNode.children) !== null && _a !== void 0 ? _a : []).find((exc) => exc.name === c.name && exc.isGroup === c.isGroup);
                    isChildGroupChanged =
                        // @ts-expect-error TS(2345): Argument of type 'GroupTreeNode | undefined' is no... Remove this comment to see the full error message
                        compareDesiredAndExisting(c, existingChild) || isChildGroupChanged;
                });
                const importChildrenIds = importNode.children.map((c) => c.element.id);
                if (existingNode) {
                    importNode.element.id = existingNode.element.id;
                    importNode.element.idInVersion = existingNode.element.idInVersion;
                    const existingChildrenIds = existingNode.children.map((c) => c.element.id);
                    // mark changed group not only if 1st level children are changed, but for lower levels as well
                    if (JSON.stringify(importChildrenIds) !==
                        JSON.stringify(existingChildrenIds) ||
                        isChildGroupChanged) {
                        toUpdate.push({
                            element: importNode.element,
                            childrenIds: importChildrenIds,
                        });
                        return true;
                    }
                }
                else {
                    toCreate.push({
                        element: importNode.element,
                        childrenIds: importChildrenIds,
                    });
                    return true;
                }
            }
            return false;
        };
        desiredStructures.forEach((typeRoots, brandId) => {
            typeRoots.forEach((typeRoot, type) => {
                compareDesiredAndExisting(typeRoot, 
                // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                exitingRoots.get(brandId).get(type));
            });
        });
        return {
            toCreate,
            toUpdate,
            toDelete,
        };
    }
}
